// module.exports = {
//     CHAIN: 80002,
//     NETWORK: "polygon-amoy",
//     Explore: 'https://amoy.polygonscan.com/',
//     projectId:'f5977011bdf8f1a31a1ea68aa2d4a606'
// }

module.exports = {
    CHAIN: 137,
    NETWORK: "polygon mainnet",
    Explore: 'https://polygonscan.com/',
    projectId: 'f5977011bdf8f1a31a1ea68aa2d4a606',
    //MOONPAY_API:'pk_test_huOJyHgm995EkzHMpL9rOeshfflH00'
}